module.exports = __webpack_public_path__ + "static/media/reports.6c1052b0.svg";